<template>
  <div class="crm-dialog-title">
    <slot name="title">
      <strong class="title">{{title}}</strong>
    </slot>
    <slot name="subtitle">
      <span class="subtitle"
            :style="subStyle">{{subtitle}}</span>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'crm-dialog-title',
  components: {
  },
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String
    },
    subStyle: {
      type: Object
    }
  },
}
</script>

<style lang="scss" scoped>
.crm-dialog-title {
}
.title {
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
}
.subtitle {
  margin-left: 20px;
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
  line-height: 35px;
}
</style>